import request from "@utils/request";

/**
 * 首页-内嵌专区接口
 * @returns {*}
 */
export function getHomeData(id) {
    return request.get(`zoneIndex?cate_id=${id}`, {}, { login: false });
}
/**
 * 
 * @param {*} id 获取首页分类列表数据
 * @returns 
 */
export function getIndexTypeList(id) {
    return request.get(`/getProCate/${id}`);
}
/**
* 
* @param {*} cate_id 
* @param {*} cate_title_id 获取分类下的数据
* @returns 
*/
export function getTypeData(cate_id, cate_title_id) {
    return request.get(`/getProLst/${cate_id}/${cate_title_id}`);
}

/**
* 首页搜索排序
* @returns {*}
*/
export function getSearchData(id, ids, data) {
    return request.get(`getProLst/${id}/${ids}`, data)
}